import home from './src/home.vue'
import DeviceManagerView from './src/broadcastManager/DeviceManagerView.vue' //广播设备列表
import DeviceManagerHttpView from './src/broadcastManager/DeviceManagerHttpView.vue' //广播设备列表
import DeviceManagerInfo from './src/broadcastManager/DeviceManagerInfo.vue' //广播设备详情
import ControlPanelView from './src/controlPanel/ControlPanelView.vue' //手动广播
import ControlPanelHttpView from './src/controlPanel/ControlPanelHttpView.vue' //手动广播
import BroadcastProgramView from './src/broadcastProgramManager/BroadcastProgramView.vue' //广播节目管理列表
import BroadcastProgramInfo from './src/broadcastProgramManager/BroadcastProgramInfo.vue' //广播节目管理详情
import BroadcastListView from './src/broadcastListManager/BroadcastListView.vue' //广播单管理列表
import BroadcastListInfo from './src/broadcastListManager/BroadcastListInfo.vue' //广播单管理详情

let views = {
    home,
    DeviceManagerView,
    DeviceManagerInfo,
    ControlPanelView,
    BroadcastProgramView,
    BroadcastProgramInfo,
    BroadcastListView,
    BroadcastListInfo,
    DeviceManagerHttpView,
    ControlPanelHttpView
};

export default views;